import { TextField, TextFieldProps } from '@mui/material';
import { Controller, Control, FieldValues, FieldError, FieldErrorsImpl, Merge } from 'react-hook-form';
import React from 'react';
import InputMask from 'react-input-mask';

interface MaskedInputProps extends Omit<TextFieldProps, 'name' | 'defaultValue' | 'inputRef'> {
  label: string;
  control: Control<any>;
  name: string;
  defaultValue?: string;
  mask?: string;
  validationError?: FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined;
  helperText?: string | undefined;
}

const InputMaskComponent: React.FC<MaskedInputProps> = ({
  control,
  name,
  defaultValue = '',
  mask,
  label,
  sx = {},
  validationError,
  helperText,
  ...rest
}) => {
  // Função para transformar o helperText em string
  const getHelperText = (): string => {
    if (typeof helperText === 'string') return helperText;
    if (helperText && 'message' in (helperText as FieldError)) return (helperText as FieldError).message || '';
    return '';
  };

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, fieldState }) => {
        const { ref, onChange, onBlur, value } = field;
        const hasError = !!fieldState.error;

        return (
          <InputMask
            mask={mask || ''}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            inputRef={ref}
            alwaysShowMask={true}
          >
            {((inputProps: any) => (
              <TextField
                {...inputProps}
                label={label}
                sx={{
                  width: '100%',
                  ...sx,
                }}
                error={hasError || false}
                helperText={getHelperText() || ''}
                {...rest}
              />
            )) as unknown as React.ReactNode}
          </InputMask>
        );
      }}
    />
  );
};

export default InputMaskComponent;
